import ClickOutside from './directives/ClickOutside';

import { App } from 'vue';
import Sticky from './directives/Sticky';
export default function (app: App) {
  ClickOutside(app);
  Sticky(app);
}
